import { compose, getContext } from 'recompose'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import moment from 'moment'
import { CMAQuestionAnswered } from 'src/constants/trackingEvents'
import { CONTEXT } from 'src/Components/shared/Wizard/WizardProvider'
import {
  selectCustomerPhone,
  selectCustomerProfile
} from 'src/store/selectors/customerProfile'
import { selectHomeData } from 'src/store/selectors/home'
import { updateHome, addHomeAnswer, trackCMARequest } from 'src/actions/home'
import { dispatchEvent } from 'src/helpers/tagManager'

const StepContainer = compose(
  getContext(CONTEXT),
  connect(
    state => ({
      agent: selectCustomerProfile(state) || {},
      phone: selectCustomerPhone(state),
      home: selectHomeData(state)
    }),
    (dispatch, props) => ({
      startCMA: preferPreviousREA => {
        dispatch(
          updateHome({
            hasRequestedCma: moment()
              .utc()
              .format()
          })
        )

        dispatch(trackCMARequest())

        if (props.previousREA) {
          dispatch(
            addHomeAnswer({
              question: 'cmaBuyersAgentPreferred',
              answer: preferPreviousREA
            })
          )
        }

        props.goForward()
      },
      setAnswer: (answerData, toStep) => {
        dispatch(addHomeAnswer(answerData))

        dispatchEvent(CMAQuestionAnswered, {
          eventLabel: `${answerData.question}:${answerData.answer}`
        })

        if (toStep) {
          props.goTo(toStep)
        } else {
          props.goForward()
        }
      }
    })
  ),
  injectIntl
)

export default StepContainer
